/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Table from './Table';
import { updateComponent, getFromJson, formatPercent } from '../util/Utils'
import { linkFormatter } from '../util/LinkFormatter'
import TrafficChart from './charts/TrafficChart';
import PropTypes from 'prop-types';
import { pmta } from '../util/HttpsClient'
import { SHORT_REFRESH_INTERVAL } from '../constants'

function makeTableData(state) {
    return {
        traffic: {
            columns: ['', 'in', 'out'],
            data: makeTraffic(state),
            title: 'Traffic Totals'
        },
        domains: {
            columns: ['name', 'recipients', '% total', '#kbytes', 'connections'],
            data: makeDomains(state),
            title: getFromJson(state, ['data', 'data', 'domainsTitle'], 'Top Domains in the Queue')
        },
        connections: {
            columns: ['', 'in', 'out'],
            data: makeConnections(state),
            title: 'Active Connections'
        },
        queueTotals: {
            columns: ['recipients', 'max', '% max'],
            data: makeQueueTotals(state),
            title: 'Queue Totals'
        }
    }
}


function makeTraffic(state) {
    let traffic = getFromJson(state, ['data', 'data', 'status', 'traffic'])
    if (!traffic) {
        return [
            ['total', 0, 0],
            ['last hour', 0, 0],
            ['top/hour', 0, 0],
            ['last minute', 0, 0],
            ['top/minute', 0, 0]
        ]
    }
    return [
        ['total', traffic.total.in.rcp, traffic.total.out.rcp],
        ['last hour', traffic.lastHr.in.rcp, traffic.lastHr.out.rcp],
        ['top/hour', traffic.topPerHr.in.rcp, traffic.topPerHr.out.rcp],
        ['last minute', traffic.lastMin.in.rcp, traffic.lastMin.out.rcp],
        ['top/minute', traffic.topPerMin.in.rcp, traffic.topPerMin.out.rcp]
    ]
}


function makeDomains(state) {
    let domains = getFromJson(state, ['data', 'data', 'domains'], [])
    let totalRcp = getFromJson(state, ['data', 'data', 'spool', 'totalRcp'], 0)
    return domains.map((d) => {
        return [d.name, d.rcp, formatPercent(d.rcp, totalRcp), d.kb, d.conn]
    })
}


function makeConnections(state) {
    let conn = getFromJson(state, ['data', 'data', 'status', 'conn'])
    if (!conn) {
        return [['SMTP', 0, 0]]
    }
    return [['SMTP', conn.smtpIn.cur, conn.smtpOut.cur]]
}


function makeQueueTotals(state) {
    let spool = getFromJson(state, ['data', 'data', 'spool'])
    if (!spool) {
        return [[0, 0, '0%']]
    }
    return [[spool.totalRcp, spool.maxRcp, spool.pctOfMaxRcp + '%']]
}


/**
 * Home page of web monitor.
 */
export default class Home extends Component {
    constructor(props) {
        super(props)
        this.refresh = this.refresh.bind(this)
        this.refreshInterval = this.refreshInterval.bind(this)
        this.state = {}
    }


    static propTypes = {
        showError: PropTypes.func.isRequired,
        setRefresh: PropTypes.func.isRequired,
        setRefreshInterval: PropTypes.func.isRequired
    };


    async componentDidMount() {
        this.props.setRefresh(this.refresh)
        this.props.setRefreshInterval(this.refreshInterval)
        this.refresh()
    }


    refresh() {
        updateComponent(this, '/', {
            showTrafficStats: 'yes'
        })
    }


    refreshInterval() {
        return SHORT_REFRESH_INTERVAL
    }


    render() {
        let tables = makeTableData(this.state)
        let domainFormatter = {
            name: linkFormatter.linkDomain
        }
        let traffic = getFromJson(this.state, ['data', 'data', 'trafficSummaryLastHour'], [])
        let ug = pmta.baseUrl() + '/getFile?file=UsersGuide.html&disposition=inline'
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <TrafficChart trafficOverTime={traffic}/>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Table columns={tables.traffic.columns}
                               data={tables.traffic.data}
                               caption={tables.traffic.title}/>
                    </Col>
                    <Col md={6}>
                        <Table columns={tables.connections.columns}
                               data={tables.connections.data}
                               caption={tables.connections.title}/>
                        <Table columns={tables.queueTotals.columns}
                               data={tables.queueTotals.data}
                               caption={tables.queueTotals.title}/>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Table columns={tables.domains.columns}
                               data={tables.domains.data}
                               caption={tables.domains.title}
                               columnFormatter={domainFormatter}
                               sort={true}
                               paginate={true}/>
                    </Col>
                </Row>
                <Row>
                    <a href={ug} target='_blank' rel="noopener noreferrer"
                       className='usersGuide'>
                        User's Guide
                    </a>
                </Row>
            </Container>
        );
    }
}
